import { useEffect, useState } from "react";
import { Scrollbars } from "react-custom-scrollbars-2";
import Candidate from "redux/models/candidate";
import { CandidateActivities } from "./candidateActivities";

export const CandidateJobEntryActivityTab = ({
  candidateJobEntryId,
  isActive,
}) => {
  const [activities, setActivities] = useState([]);

  const getActivities = async () => {
    try {
      const res = await Candidate.getLogs(candidateJobEntryId);
      setActivities(res);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    getActivities();
  }, [candidateJobEntryId, isActive]);

  return (
    <Scrollbars style={{ height: 400 }}>
      <CandidateActivities data={activities} />
    </Scrollbars>
  );
};
